import { Highlight, connectRefinementList } from 'react-instantsearch-dom'
import { DeviceCategory } from 'mobily-ui-library/lib'
import { useTranslation } from 'react-i18next'
import Phones from '../../assets/DeviceCategories/Phones.png'
import Tablets from '../../assets/DeviceCategories/Tablets.png'
import Consoles from '../../assets/DeviceCategories/Consoles.png'
import Laptops from '../../assets/DeviceCategories/Laptops.png'
import Routers from '../../assets/DeviceCategories/Routers.png'
import Accessories from '../../assets/DeviceCategories/Accessories.png'
import './DeviceCategories.scss'

const RefinementList = ({
  items,
  isFromSearch,
  refine,
  createURL,
}: {
  items: any
  isFromSearch: any
  refine: any
  createURL: any
}) => {
  const { t } = useTranslation()
  const deviceCategories = {
    [t('Phones')]: Phones,
    [t('Tablets')]: Tablets,
    [t('Consoles')]: Consoles,
    [t('Laptops')]: Laptops,
    [t('Routers')]: Routers,
    [t('Accessories')]: Accessories,
  }
  return (
    <div className="deviceCategories_container">
      <ul className="deviceCategories">
        {items.map(
          (item: any) =>
            // Temporary fix for data issue in ar page
            Object.keys(deviceCategories).includes(item.label) && (
              <li key={item.label}>
                <a
                  className="deviceFilter"
                  href={createURL(item.value)}
                  onClick={event => {
                    console.log(item)
                    event.preventDefault()
                    refine(item.value)
                  }}
                >
                  {isFromSearch ? (
                    <Highlight attribute="label" hit={item} />
                  ) : (
                    <DeviceCategory
                      image={deviceCategories[item.label]}
                      label={item.label}
                      isRefined={item.isRefined}
                      alt={item.label}
                    />
                  )}
                </a>
              </li>
            )
        )}
      </ul>
    </div>
  )
}

const RefinedCategories = connectRefinementList(RefinementList)

export default RefinedCategories
